import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Lock, Mail, Eye, EyeOff } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.bg} />
      <div style={styles.card}>
        <div style={styles.brand}>
          <div style={styles.brandIcon}>D</div>
          <span style={styles.brandText}>Dami<span style={{ color: '#8BC63E' }}>tove</span></span>
        </div>
        <h2 style={styles.title}>Welcome back</h2>
        <p style={styles.subtitle}>Sign in to manage your smart lockers</p>
        
        {error && <div style={styles.error}>{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div style={styles.inputGroup}>
            <Mail size={16} style={styles.inputIcon} />
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
          </div>
          <div style={styles.inputGroup}>
            <Lock size={16} style={styles.inputIcon} />
            <input
              type={showPw ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              required
            />
            <button type="button" onClick={() => setShowPw(!showPw)} style={styles.eyeBtn}>
              {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
          <button type="submit" style={styles.btn} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#07080c', position: 'relative', overflow: 'hidden',
  },
  bg: {
    position: 'absolute', top: '-50%', left: '-50%', width: '200%', height: '200%',
    background: 'radial-gradient(circle at 30% 40%, rgba(139,198,62,0.06) 0%, transparent 50%), radial-gradient(circle at 70% 60%, rgba(77,144,254,0.04) 0%, transparent 50%)',
  },
  card: {
    background: '#0f1117', border: '1px solid #252733', borderRadius: 16,
    padding: '48px 40px', width: 420, maxWidth: '90vw', position: 'relative', zIndex: 1,
  },
  brand: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32 },
  brandIcon: {
    width: 36, height: 36, background: 'linear-gradient(135deg, #8BC63E, #00b4d8)',
    borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: 800, fontSize: 16, color: '#07080c',
  },
  brandText: { fontWeight: 700, fontSize: 20, color: '#e4e5ed', letterSpacing: -0.5 },
  title: { fontSize: 24, fontWeight: 700, color: '#e4e5ed', marginBottom: 6 },
  subtitle: { fontSize: 14, color: '#8789a0', marginBottom: 28 },
  error: {
    background: 'rgba(255,68,102,0.1)', border: '1px solid rgba(255,68,102,0.2)',
    borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#ff4466', marginBottom: 16,
  },
  inputGroup: {
    position: 'relative', marginBottom: 14,
  },
  inputIcon: {
    position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
    color: '#565870', pointerEvents: 'none',
  },
  input: {
    width: '100%', background: '#161821', border: '1px solid #252733', borderRadius: 10,
    padding: '13px 14px 13px 40px', fontSize: 14, color: '#e4e5ed', outline: 'none',
    transition: 'border-color 0.2s', boxSizing: 'border-box',
  },
  eyeBtn: {
    position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
    background: 'none', border: 'none', color: '#565870', cursor: 'pointer', padding: 4,
  },
  btn: {
    width: '100%', padding: '13px 0', background: '#8BC63E', color: '#07080c',
    border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: 'pointer',
    marginTop: 8, transition: 'all 0.15s',
  },
};

